import {
    ABOVE_THE_HEADER,
    CHANGE_DIRECTION,
    CHANGE_NAVIGATION_STYLE,
    DARK_THEME,
    DRAWER_TYPE,
    COLLAPSED_DRAWER,
    HORIZONTAL_MENU_POSITION,
    SWITCH_LANGUAGE,
    THEME_COLOR,
    TOGGLE_COLLAPSED_NAV,
    VERTICAL_NAVIGATION,
    WINDOW_WIDTH,
    WINDOW_HEIGHT,
    COLOR_OPTIONS_MODAL,
    USER_INFO_MODAL,
    CLEAR_SESSION,
} from 'constants/ActionTypes';
import { DARK_CYAN } from 'constants/ThemeColors';

const rltLocale = ['ar'];
const initialSettings = {
    navCollapsed: false,
    drawerType: COLLAPSED_DRAWER,
    themeColor: DARK_CYAN,
    darkTheme: false,
    width: window.innerWidth,
    height: window.innerHeight,
    isDirectionRTL: false,
    navigationStyle: VERTICAL_NAVIGATION,
    horizontalNavPosition: ABOVE_THE_HEADER,
    locale: {
        languageId: 'english',
        locale: 'en',
        name: 'English',
        icon: 'us'
    },
    colorOptionsModal: false,
    userInfoModal: false,
};

const settings = (state = initialSettings, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                navCollapsed: false
            };
        case CLEAR_SESSION: {
            return {
                ...initialSettings,
            };
        }
        case TOGGLE_COLLAPSED_NAV:
            return {
                ...state,
                navCollapsed: action.isNavCollapsed
            };
        case DRAWER_TYPE:
            return {
                ...state,
                drawerType: action.drawerType
            };
        case WINDOW_WIDTH:
            return {
                ...state,
                width: action.width
            };
        case WINDOW_HEIGHT:
            return {
                ...state,
                height: action.height
            };
        case THEME_COLOR:
            return {
                ...state,
                darkTheme: false,
                themeColor: action.color
            };
        case DARK_THEME:
            return {
                ...state,
                darkTheme: !state.darkTheme
            };
        case SWITCH_LANGUAGE:

            return {
                ...state,
                locale: action.payload,
                isDirectionRTL: rltLocale.includes(action.payload.locale)

            };
        case CHANGE_DIRECTION:
            return {
                ...state,
                isDirectionRTL: !state.isDirectionRTL

            };

        case CHANGE_NAVIGATION_STYLE:
            return {
                ...state,
                navigationStyle: action.payload
            };


        case HORIZONTAL_MENU_POSITION:
            return {
                ...state,
                horizontalNavPosition: action.payload
            };

        case COLOR_OPTIONS_MODAL:
            return {
                ...state,
                colorOptionsModal: !state.colorOptionsModal
            };

        case USER_INFO_MODAL:
            return {
                ...state,
                userInfoModal: !state.userInfoModal
            };


        default:
            return state;
    }
};

export default settings;



// WEBPACK FOOTER //
// ./reducers/Settings.js